import callOptions from './callOptions'
import constants from '../../utils/constants'
import { getPhoneSession, getCall, setCall } from './sessionHandler'
import { get, set } from '../../utils/session-handler'
import { formatTimer } from '../../utils/utils'

const callHistory = (number, timer, isAccept) => {

  const recentContacts = get('recentContacts') !== undefined ? JSON.parse(get('recentContacts')) : []

  const callHours = new Date().toLocaleTimeString()
  const callDate = new Date().toLocaleDateString()
  const callTimer = timer !== null ? formatTimer(timer) : 0

  const recentContact = recentContacts.find((recentContact) => recentContact.callNumber === number &&  recentContact.callTimer === callTimer)

  if (recentContact !== undefined) return

  const contact = { id: (recentContacts.length+1), callNumber: number, callHours, callDate, callTimer, isAccept }

  recentContacts.unshift(contact)

  set('recentContacts', JSON.stringify(recentContacts))
}

const placeCall = number => {
  const targetURI = `sip:${number}@${constants.SIP_DOMAIN}`
  
  const phone = getPhoneSession()

  const call = phone.call(targetURI, callOptions)

  setCall(call)
}

const ongoingCall = number => {
  const call = getCallSession()

  call.sendDTMF(number)
}

const endCall = () => {
  const phone = getPhoneSession()

  phone.terminateSessions()

  setCall(undefined)
}

const muteMicrophoneToggle = () => {
  const call = getCallSession()

  const options = {
    audio: true,
  }

  isMuted() ? call.unmute(options) : call.mute(options)
}

const isMuted = () => {
  const call = getCallSession()

  return call.isMuted().audio
}

const getCallSession = () => {
  const call = getCall()

  return call.session ? call.session : call
}

export { placeCall, ongoingCall, endCall, muteMicrophoneToggle, isMuted, callHistory }
